import { all } from 'redux-saga/effects';
import opportunitySaga from './opportunitySaga';

export default function* rootSaga(action) {
	yield all([opportunitySaga(action)]);
}
